import {
  createContext,
  useEffect,
  useState,
  ReactNode,
  Dispatch,
  SetStateAction,
} from "react";
import { DateRangeProvider } from "./DateRangeContext";

export interface DistributionPoint {
  id: string;
  name: string;
}

interface DistributionPointContextType {
  distributionPoint: DistributionPoint | undefined;
  setDistributionPoint: Dispatch<SetStateAction<DistributionPoint>>;
}
const defaultValue: DistributionPointContextType = {
  distributionPoint: undefined,
  setDistributionPoint: () => {
    throw new Error(
      "setDistributionPoint debe usarse dentro del MyDistributionPoint.Provider"
    );
  },
};

const DistributionPointSelected =
  createContext<DistributionPointContextType>(defaultValue);

interface MyDistributionPointProps {
  children: ReactNode;
}

export const MyDistributionPoint = ({ children }: MyDistributionPointProps) => {
  const [distributionPoint, setDistributionPoint] = useState(() => {
    const storedValue = localStorage.getItem("distributionPoint");
    return storedValue ? JSON.parse(storedValue) : undefined;
  });

  useEffect(() => {
    localStorage.setItem(
      "distributionPoint",
      JSON.stringify(distributionPoint)
    );
  }, [distributionPoint]);

  return (
    <DistributionPointSelected.Provider
      value={{ distributionPoint, setDistributionPoint }}
    >
      <DateRangeProvider>{children}</DateRangeProvider>
    </DistributionPointSelected.Provider>
  );
};

export default DistributionPointSelected;
